import { render, staticRenderFns } from "./privateComponent.vue?vue&type=template&id=46c5bf20"
import script from "./privateComponent.vue?vue&type=script&lang=js"
export * from "./privateComponent.vue?vue&type=script&lang=js"
import style0 from "./privateComponent.vue?vue&type=style&index=0&id=46c5bf20&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46c5bf20')) {
      api.createRecord('46c5bf20', component.options)
    } else {
      api.reload('46c5bf20', component.options)
    }
    module.hot.accept("./privateComponent.vue?vue&type=template&id=46c5bf20", function () {
      api.rerender('46c5bf20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/privateComponent.vue"
export default component.exports